import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, Optional } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiRadioService } from "../../services/radio.service";
import { NzRadioGroupComponent } from "ng-zorro-antd/radio";
import { UiRadioButtonStyle } from "../../models/radio-button.models";
import { UiSizeLDSType } from "@webapp/ui/core/models/ui-size.models";

/* Passing the nzName property to all input[type="radio"] that are in the same RadioGroup.
 * It is usually used to let the browser see your ui-radio-group as a real "group" and keep the default behavior.
 * For example, using left/right keyboard arrow to change your selection that in the same ui-radio-group.
 */

@Component({
  selector: "ui-radio-group",
  exportAs: "uiRadioGroup",
  templateUrl: "./radio-group.component.html",
  styleUrls: ["./radio-group.component.less"],
  providers: [
    UiRadioService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiRadioGroupComponent),
      multi: true,
    },
  ],
})
export class UiRadioGroupComponent extends NzRadioGroupComponent {
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiButtonStyle") public nzButtonStyle: UiRadioButtonStyle = "outline";
  @Input("uiSize") public nzSize: UiSizeLDSType = "default";
  @Input("uiName") public nzName: string | null = null;

  constructor(cdr: ChangeDetectorRef, uiRadioService: UiRadioService, elementRef: ElementRef, @Optional() directionality: Directionality) {
    super(cdr, uiRadioService, elementRef, directionality);
  }
}
